import React from 'react';
import classnames from 'classnames';
import paperPlane from 'v2/icons/paperPlane.svg';

interface IResubmitRequestButtonProps {
  onClick: () => void;
  isReSubmittingToNomadInProgress: boolean;
}

export const ResubmitRequestButton = ({
  onClick,
  isReSubmittingToNomadInProgress,
}: IResubmitRequestButtonProps) => {
  return (
    <button
      className={classnames('mr-2', 'btn btn-primary', 'editBtn')}
      onClick={onClick}
      title={'Send to Reviewer'}
      disabled={isReSubmittingToNomadInProgress}
    >
      <img src={paperPlane} alt={'paperPlaneIcon'} className={'pr-2'}></img>
      Resubmit
    </button>
  );
};
